import {Avatar, AvatarFallback, AvatarImage} from '@/base/ui/avatar'
import {cn} from '@/lib/utils'
import React, {useRef, useState} from 'react'
import {useOnClickOutside} from '../../hooks/useOnClickOutsideHook'
import {IWuAppHeaderAccount} from '../../types/WuAppHeaderAccount'
import {LogoutMenuItem} from './ui/_logoutMenuItem'
import {OtherMenuItem} from './ui/_otherMenuItem'
import {SettingsMenuItem} from './ui/_settingsMenuItem'
import {UserMenuItem} from './ui/_userMenuItem'

interface IWuAppHeaderAccountProps {
  user?: IWuAppHeaderAccount
  onLogout?: () => void
  dir?: 'ltr' | 'rtl'
  DataCenter?: React.ReactElement
}

export const WuAppHeaderAccount: React.FC<IWuAppHeaderAccountProps> = ({
  user,
  onLogout,
  dir,
  DataCenter,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement | null>(null)
  const buttonRef = useRef<HTMLButtonElement>(null)

  useOnClickOutside([dropdownRef, buttonRef], () => setIsOpen(false))

  const toggleDropdown = (): void => {
    setIsOpen(!isOpen)
  }

  if (!user) return null

  return (
    <>
      <div className="dropdown-container">
        <ul>
          <li className={cn('flex relative', isOpen && 'open')}>
            <button
              className="rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-soft focus-visible:ring-offset-2 focus-visible:ring-offset-gray-switcher w-8 h-8 wu-app-user-button"
              onClick={e => {
                e.preventDefault()
                toggleDropdown()
              }}
              ref={buttonRef}
              aria-label="user-avatar"
            >
              <Avatar
                className={cn(
                  'group border border-white text-sm font-medium bg-transparent w-8 h-8 ring-white leading-[33px] text-white transition-colors hover:bg-white hover:text-gray-switcher wu-header-user-avatar',
                  isOpen && 'bg-white text-gray-switcher',
                )}
              >
                <AvatarImage
                  className="hover:opacity-80"
                  src={user?.profile?.profilePicture}
                  alt="User"
                />
                <AvatarFallback>{user?.profile?.initials}</AvatarFallback>
              </Avatar>
            </button>
            <div
              className={cn(
                'dropdown-menu',
                {open: isOpen},
                dir === 'rtl'
                  ? '-left-[10px] top-[38px]'
                  : '-right-[7px] top-[38px]',
              )}
              dir={dir}
              ref={dropdownRef}
              aria-label="user-menu"
            >
              <div
                className={cn(
                  'p-0 text-xs font-medium border rounded-none min-w-72 w-max max-w-96 border-gray-subtle text-gray-lead overflow-hidden bg-white',
                )}
                dir={dir}
                ref={dropdownRef}
              >
                <UserMenuItem user={user} dir={dir} />
                {user?.settings && user.settings.length > 0 && (
                  <SettingsMenuItem settings={user.settings} dir={dir} />
                )}
                <OtherMenuItem user={user} dir={dir} />
                <LogoutMenuItem onLogout={onLogout} DataCenter={DataCenter} />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </>
  )
}
